.root {
  min-height: 100vh;
  display: flex;
}

.banner {
  flex: 1.3;
  background-size: cover;
  background-position: 92% 55%;
  position: relative;
}

.banner::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, rgba(11, 37, 69, 0.28), rgba(11, 37, 69, 0.05));
}

.panel {
  flex: 1;
  min-width: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface);
  padding: 32px;
}

.card {
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  text-align: center;
}

.logo {
  width: 100%;
  max-width: 280px;
}

.productBlock {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.productEyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--color-brand-secondary);
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: var(--color-brand-primary);
  letter-spacing: -0.01em;
}

.subtitle {
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.5;
  max-width: 320px;
}

.signInButton {
  width: 100%;
  height: 44px;
  font-size: 14.5px;
}

.modeNotice {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 12px;
  color: var(--color-text-tertiary);
  padding-top: 4px;
}

@media (max-width: 900px) {
  .banner {
    display: none;
  }

  .panel {
    min-width: 0;
  }
}
